import { useGlobalDataContext } from "@/components/GlobalDataContext";

export const useGlobalTranslations = (keys: string[]) => {
  const { globalTranslations } = useGlobalDataContext();

  return keys.reduce((acc: Record<string, string>, key: string) => {
    const data = globalTranslations.find(
      (currentVariable) => currentVariable.key === key,
    );

    acc[key] = data?.text || "";
    return acc;
  }, {});
};
